module.exports = {"title":"This is a high-cost credit","content":"If you cannot repay the entire debt, you risk a payment note. For support, turn to the budget and debt counseling in your municipality. Contact details can be found on {{ link }}"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/alert.json
// module id = 508
// module chunks = 245 991